import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import LinkIcon from "@mui/icons-material/Link";
import HistoryIcon from "@mui/icons-material/History";
import PersonIcon from "@mui/icons-material/Person";
import type { SvgIconComponent } from "@mui/icons-material";

export const DRAWER_WIDTH = 256;

export interface NavItem {
  label: string;
  i18nKey: string;
  path: string;
  icon: SvgIconComponent;
  requiresAuth: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  {
    label: "Upload",
    i18nKey: "nav.upload",
    path: "/dashboard",
    icon: CloudUploadIcon,
    requiresAuth: true,
  },
  {
    label: "My Files",
    i18nKey: "nav.myFiles",
    path: "/files",
    icon: FolderOpenIcon,
    requiresAuth: true,
  },
  {
    label: "Shared Links",
    i18nKey: "nav.sharedLinks",
    path: "/links",
    icon: LinkIcon,
    requiresAuth: true,
  },
  {
    label: "Upload history",
    i18nKey: "nav.uploadHistory",
    path: "/history",
    icon: HistoryIcon,
    requiresAuth: true,
  },
  {
    label: "Account",
    i18nKey: "nav.account",
    path: "/account",
    icon: PersonIcon,
    requiresAuth: false,
  },
];
